export enum ReportCategory {
    IssuerReports = "Issuer Reports",
    InvestorReports = "Investor Reports",
    CombinedReports = "Combined Reports",
    SystemReports = "System Reports",
    Exports = "Exports",
    Example = "Example Reports"
}